import {
  Paintbrush, Building2, Bath, ShowerHead, Wrench, Grid3x3, Hammer,
  DoorOpen, DoorClosed, Layers, Ruler, Droplets, PanelTop, SquarePen,
  Brush, Home, Store, Briefcase, Sparkles, ShieldCheck, Clock, Package,
  MessageSquare, RefreshCw, BadgeCheck, Zap,
} from "lucide-react";

export const SERVICES = [
  { name: "Imbiancatura appartamenti", icon: Paintbrush },
  { name: "Pittura interni", icon: Brush },
  { name: "Pittura uffici", icon: Briefcase },
  { name: "Pittura negozi", icon: Store },
  { name: "Tinteggiatura completa", icon: Paintbrush },
  { name: "Rifacimento bagno", icon: Bath },
  { name: "Rifacimento doccia", icon: ShowerHead },
  { name: "Sostituzione sanitari", icon: Bath },
  { name: "Piastrellatura", icon: Grid3x3 },
  { name: "Piccoli lavori di muratura", icon: Hammer },
  { name: "Costruzione pareti", icon: Building2 },
  { name: "Demolizione tramezzi", icon: Hammer },
  { name: "Apertura porte", icon: DoorOpen },
  { name: "Chiusura porte", icon: DoorClosed },
  { name: "Mensole in muratura", icon: PanelTop },
  { name: "Nicchie in cartongesso", icon: Layers },
  { name: "Ripristino intonaci", icon: Ruler },
  { name: "Rasature", icon: SquarePen },
  { name: "Riparazione muri", icon: Wrench },
  { name: "Riparazione infiltrazioni", icon: Droplets },
  { name: "Cartongesso", icon: Layers },
  { name: "Stuccature", icon: SquarePen },
  { name: "Sigillature", icon: Droplets },
  { name: "Riparazioni domestiche", icon: Home },
  { name: "Manutenzioni", icon: Wrench },
  { name: "Interventi urgenti", icon: Zap },
];

export const BENEFITS = [
  { title: "Preventivo gratuito", desc: "Valutazione senza impegno, in tempi rapidi.", icon: BadgeCheck },
  { title: "Risposta rapida", desc: "Ti rispondiamo su WhatsApp nel più breve tempo possibile.", icon: Clock },
  { title: "Interventi veloci", desc: "Organizziamo il lavoro per ridurre al minimo i tempi.", icon: Zap },
  { title: "Lavori puliti", desc: "Cantiere ordinato e pulizia a fine intervento.", icon: Sparkles },
  { title: "Cura dei dettagli", desc: "Finiture precise, senza sbavature.", icon: Ruler },
  { title: "Materiali di qualità", desc: "Prodotti affidabili e duraturi.", icon: Package },
  { title: "Comunicazione semplice", desc: "Un unico riferimento diretto per tutto.", icon: MessageSquare },
  { title: "Aggiornamenti costanti", desc: "Ti teniamo informato durante il lavoro.", icon: RefreshCw },
];

export const GALLERY = [
  { url: "https://images.unsplash.com/photo-1661107259637-4e1c55462428?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cat: "Bagni", label: "Bagno moderno con specchio" },
  { url: "https://images.pexels.com/photos/7587289/pexels-photo-7587289.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Bagni", label: "Vasca e piastrelle chiare" },
  { url: "https://images.pexels.com/photos/8146325/pexels-photo-8146325.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Bagni", label: "Bagno con dettagli in legno" },
  { url: "https://images.pexels.com/photos/6764270/pexels-photo-6764270.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Pitture", label: "Tinteggiatura parete" },
  { url: "https://images.pexels.com/photos/1669754/pexels-photo-1669754.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Pitture", label: "Rullo su parete bianca" },
  { url: "https://images.unsplash.com/photo-1704005445445-2747074be8ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cat: "Muratura", label: "Posa mattoni con cazzuola" },
  { url: "https://images.pexels.com/photos/19688828/pexels-photo-19688828.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Muratura", label: "Muratura di precisione" },
  { url: "https://images.unsplash.com/photo-1778514825881-046a3213a4a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cat: "Cartongesso", label: "Struttura in costruzione" },
  { url: "https://images.pexels.com/photos/4981812/pexels-photo-4981812.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Cartongesso", label: "Installazione cartongesso" },
  { url: "https://images.pexels.com/photos/29181494/pexels-photo-29181494.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", cat: "Pavimenti", label: "Posa piastrelle" },
  { url: "https://images.unsplash.com/photo-1731185752376-a4cf3e8556fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cat: "Pavimenti", label: "Livellamento pavimento" },
  { url: "https://images.unsplash.com/photo-1768321903466-313ed74cbb62?crop=entropy&cs=srgb&fm=jpg&q=85&w=940", cat: "Pareti", label: "Nuove pareti e strutture" },
];

export const GALLERY_CATS = ["Tutti", "Bagni", "Pitture", "Cartongesso", "Muratura", "Pavimenti", "Pareti"];

export const REVIEWS = [
  { name: "Giulia R.", zone: "Prati, Roma", text: "Hanno imbiancato tutto l'appartamento in due giorni. Puliti, precisi e sempre disponibili su WhatsApp. Consigliatissimi.", rating: 5 },
  { name: "Marco T.", zone: "Monteverde, Roma", text: "Rifacimento completo del bagno. Preventivo chiaro, tempi rispettati e risultato eccellente. Ci siamo trovati benissimo.", rating: 5 },
  { name: "Elena B.", zone: "Trieste, Roma", text: "Avevo un'infiltrazione e una parete da sistemare. Sono venuti in fretta e hanno risolto tutto. Comunicazione semplice e diretta.", rating: 5 },
  { name: "Davide M.", zone: "EUR, Roma", text: "Nicchie in cartongesso e tinteggiatura del soggiorno. Cura dei dettagli davvero notevole. Torneremo a chiamarli.", rating: 5 },
  { name: "Sara P.", zone: "San Giovanni, Roma", text: "Piccoli lavori di muratura fatti a regola d'arte. Preventivo gratuito e nessuna sorpresa sul prezzo finale.", rating: 5 },
  { name: "Luca F.", zone: "Ostiense, Roma", text: "Piastrellatura del terrazzo perfetta. Professionali dall'inizio alla fine, mi hanno aggiornato ogni giorno.", rating: 5 },
];

export const QUOTE_TYPES = [
  "Imbiancatura / Tinteggiatura",
  "Rifacimento bagno",
  "Piastrellatura",
  "Muratura / Pareti",
  "Cartongesso",
  "Intonaci / Rasature",
  "Riparazioni / Manutenzioni",
  "Intervento urgente",
  "Altro",
];

export const ROME_ZONES = [
  "Centro", "Prati", "Trastevere", "Monteverde", "EUR", "Ostiense",
  "San Giovanni", "Trieste / Salario", "Parioli", "Nomentano", "Tuscolano",
  "Appio", "Aurelio", "Flaminio", "Portuense", "Fuori Roma", "Altra zona",
];
